import { render } from "./EventData.vue?vue&type=template&id=fd4645b8&scoped=true"
import script from "./EventData.vue?vue&type=script&setup=true&lang=js"
export * from "./EventData.vue?vue&type=script&setup=true&lang=js"

import "./EventData.vue?vue&type=style&index=0&id=fd4645b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4645b8"],['__file',"src/pages/scada/EventData/EventData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd4645b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd4645b8', __exports__)) {
    console.log('reload')
    api.reload('fd4645b8', __exports__)
  }
  
  module.hot.accept("./EventData.vue?vue&type=template&id=fd4645b8&scoped=true", () => {
    console.log('re-render')
    api.rerender('fd4645b8', render)
  })

}


export default __exports__